export const defaultAreaProps = {
    legendPlacement: 'right',
    legendLabelOverflowMode: 'ellipsisMiddle',
    legendMode: 'standard',
    masterLegend: null,
    resultTruncationLimit: 50000,
    xAxisVisibility: 'hide',
    yAxisVisibility: 'hide',
    yAxisExtendsAxisRange: true,
    xAxisMajorLabelVisibility: 'auto',
    yAxisMajorLabelVisibility: 'auto',
    xAxisMajorTickSize: 6,
    yAxisMajorTickSize: 6,
    yAxisMinorTickSize: 6,
    xAxisMajorTickVisibility: 'hide',
    yAxisMajorTickVisibility: 'hide',
    yAxisMajorUnit: 'auto',
    yAxisMinorTickVisibility: 'auto',
    yAxisAbbreviation: 'none',
    yAxisIncludeZero: false,
    xAxisMax: 'auto',
    yAxisMax: 'auto',
    yAxisMin: 'auto',
    yAxisScale: 'linear',
    xAxisTitleVisibility: 'visible',
    yAxisTitleVisibility: 'visible',
    showMajorYGridLines: true,
    showMinorYGridLines: false,
    y2AxisMajorLabelVisibility: 'auto',
    y2AxisMajorTickSize: 6,
    y2AxisMinorTickSize: 6,
    y2AxisMajorTickVisibility: 'hide',
    y2AxisMajorUnit: 'auto',
    y2AxisMinorTickVisibility: 'auto',
    y2AxisAbbreviation: 'none',
    roundY2AxisLabelsToInteger: false,
    y2AxisIncludeZero: false,
    y2AxisMax: 'auto',
    y2AxisMin: 'auto',
    y2AxisScale: 'linear',
    y2AxisTitleVisibility: 'visible',
    showMajorY2GridLines: true,
    showMinorY2GridLines: false,
    y2AxisVisibility: 'hide',
    enableY2Axis: false,
    fieldListMode: 'hide_show',
    xAxisMajorLabelRotation: 0,
    showMajorXGridLines: true,
    splitSeries: false,
    allowIndependentYRanges: false,
    showDataLabels: 'none',
    stackMode: 'default',
    areaFillOpacity: 0.75,
    nullValueMode: 'gaps',
    showLines: true,
    xAxisTitleAlignment: 'low',
    yAxisTitleAlignment: 'low',
    y2AxisTitleAlignment: 'low',
    areaLineCap: 'round',
    areaLineWidth: 1.5,
    lineWidth: 2,
    xAxisMaxLabelParts: 3,
};

export const defaultColumnProps = {
    legendPlacement: 'right',
    legendLabelOverflowMode: 'ellipsisMiddle',
    masterLegend: null,
    resultTruncationLimit: 50000,
    xAxisVisibility: 'hide',
    yAxisVisibility: 'hide',
    yAxisExtendsAxisRange: true,
    xAxisMajorLabelVisibility: 'auto',
    yAxisMajorLabelVisibility: 'auto',
    xAxisMajorTickSize: 6,
    yAxisMajorTickSize: 6,
    yAxisMinorTickSize: 6,
    xAxisMajorTickVisibility: 'auto',
    yAxisMajorTickVisibility: 'auto',
    yAxisMajorUnit: 'auto',
    yAxisMinorTickVisibility: 'auto',
    yAxisAbbreviation: 'none',
    yAxisIncludeZero: false,
    xAxisMax: 'auto',
    yAxisMax: 'auto',
    yAxisMin: 'auto',
    yAxisScale: 'linear',
    xAxisTitleVisibility: 'visible',
    yAxisTitleVisibility: 'visible',
    showMajorYGridLines: true,
    showMinorYGridLines: false,
    y2AxisMajorLabelVisibility: 'auto',
    y2AxisMajorTickSize: 6,
    y2AxisMinorTickSize: 6,
    y2AxisMajorTickVisibility: 'auto',
    y2AxisMajorUnit: 'auto',
    y2AxisMinorTickVisibility: 'auto',
    y2AxisAbbreviation: 'none',
    roundY2AxisLabelsToInteger: false,
    y2AxisIncludeZero: false,
    y2AxisMax: 'auto',
    y2AxisMin: 'auto',
    y2AxisScale: 'linear',
    y2AxisTitleVisibility: 'visible',
    showMajorY2GridLines: true,
    showMinorY2GridLines: false,
    y2AxisVisibility: 'hide',
    enableY2Axis: false,
    fieldListMode: 'hide_show',
    xAxisMajorLabelRotation: 0,
    showMajorXGridLines: false,
    splitSeries: false,
    allowIndependentYRanges: false,
    showDataLabels: 'none',
    stackMode: 'default',
    columnGrouping: 'default',
    columnFillOpacity: 1,
    lineWidth: 2,
    xAxisMaxLabelParts: 3,
    showTooltip: true,
};

export const defaultLineProps = {
    legendPlacement: 'right',
    legendLabelOverflowMode: 'ellipsisMiddle',
    legendMode: 'standard',
    masterLegend: null,
    resultTruncationLimit: 50000,
    xAxisVisibility: 'hide',
    yAxisVisibility: 'hide',
    yAxisExtendsAxisRange: true,
    xAxisMajorLabelVisibility: 'auto',
    yAxisMajorLabelVisibility: 'auto',
    xAxisMajorTickSize: 6,
    yAxisMajorTickSize: 6,
    yAxisMinorTickSize: 6,
    xAxisMajorTickVisibility: 'hide',
    yAxisMajorTickVisibility: 'hide',
    yAxisMajorUnit: 'auto',
    yAxisMinorTickVisibility: 'auto',
    yAxisAbbreviation: 'none',
    yAxisIncludeZero: false,
    xAxisMax: 'auto',
    yAxisMax: 'auto',
    yAxisMin: 'auto',
    yAxisScale: 'linear',
    xAxisTitleVisibility: 'visible',
    yAxisTitleVisibility: 'visible',
    showMajorYGridLines: true,
    showMinorYGridLines: false,
    y2AxisMajorLabelVisibility: 'auto',
    y2AxisMajorTickSize: 6,
    y2AxisMinorTickSize: 6,
    y2AxisMajorTickVisibility: 'hide',
    y2AxisMajorUnit: 'auto',
    y2AxisMinorTickVisibility: 'auto',
    y2AxisAbbreviation: 'none',
    roundYAxisLabelsToInteger: false,
    roundY2AxisLabelsToInteger: false,
    y2AxisIncludeZero: false,
    y2AxisMax: 'auto',
    y2AxisMin: 'auto',
    y2AxisScale: 'linear',
    y2AxisTitleVisibility: 'visible',
    showMajorY2GridLines: true,
    showMinorY2GridLines: false,
    y2AxisVisibility: 'hide',
    enableY2Axis: false,
    fieldListMode: 'hide_show',
    xAxisMajorLabelRotation: 0,
    showMajorXGridLines: true,
    splitSeries: false,
    allowIndependentYRanges: false,
    showDataLabels: 'none',
    nullValueMode: 'gaps',
    lineDashStyle: 'solid',
    lineWidth: 2,
    showMarkers: true,
    showMarkerHalo: false,
    lineMarkerStyle: 'hollow',
    xAxisTitleAlignment: 'low',
    yAxisTitleAlignment: 'low',
    y2AxisTitleAlignment: 'low',
    xAxisMaxLabelParts: 3,
};

export const defaultBarProps = {
    legendPlacement: 'right',
    legendLabelOverflowMode: 'ellipsisMiddle',
    masterLegend: null,
    resultTruncationLimit: 50000,
    xAxisVisibility: 'hide',
    yAxisVisibility: 'hide',
    yAxisExtendsAxisRange: true,
    xAxisMajorLabelVisibility: 'auto',
    yAxisMajorLabelVisibility: 'auto',
    xAxisMajorTickSize: 6,
    yAxisMajorTickSize: 6,
    yAxisMinorTickSize: 6,
    xAxisMajorTickVisibility: 'auto',
    yAxisMajorTickVisibility: 'auto',
    yAxisMajorUnit: 'auto',
    yAxisMinorTickVisibility: 'auto',
    yAxisAbbreviation: 'none',
    yAxisIncludeZero: false,
    xAxisMax: 'auto',
    yAxisMax: 'auto',
    yAxisMin: 'auto',
    yAxisScale: 'linear',
    xAxisTitleVisibility: 'visible',
    yAxisTitleVisibility: 'visible',
    showMajorYGridLines: true,
    showMinorYGridLines: false,
    y2AxisMajorLabelVisibility: 'auto',
    y2AxisMajorTickSize: 6,
    y2AxisMinorTickSize: 6,
    y2AxisMajorTickVisibility: 'auto',
    y2AxisMajorUnit: 'auto',
    y2AxisMinorTickVisibility: 'auto',
    y2AxisAbbreviation: 'none',
    roundY2AxisLabelsToInteger: false,
    y2AxisIncludeZero: false,
    y2AxisMax: 'auto',
    y2AxisMin: 'auto',
    y2AxisScale: 'linear',
    y2AxisTitleVisibility: 'visible',
    showMajorY2GridLines: true,
    showMinorY2GridLines: false,
    y2AxisVisibility: 'hide',
    enableY2Axis: false,
    fieldListMode: 'hide_show',
    splitSeries: false,
    allowIndependentYRanges: false,
    showDataLabels: 'none',
    stackMode: 'default',
    lineWidth: 2,
    xAxisMaxLabelParts: 3,
};

export const defaultPunchcardProps = {
    theme: undefined,
    backgroundColor: 'transparent',
    showBubbleLabels: 'all',
    bubbleRowScale: 'global',
    bubbleScale: 'area',
    category: null,
    colorMode: 'categorical',
    seriesColors: [
        '#7B56DB',
        '#0089CF',
        '#00CDAF',
        '#DD9900',
        '#FF677B',
        '#CB2196',
        '#813193',
        '#0051B5',
        '#008C80',
        '#99B100',
        '#FFA476',
        '#FF6ACE',
        '#AE8CFF',
        '#00689D',
        '#00490A',
        '#465D00',
        '#9D6300',
        '#F6540B',
        '#FF969E',
        '#E47BFE',
    ],
    bubbleColor: '#7B56DB',
    minBubbleColorIntensity: 0.25,
    showMaxValuePulsation: true,
    height: 500,
    width: '100%',
    isBubbleSizeDynamic: true,
    minBubbleSize: 0.25,
    maxBubbleSize: 1,
    maxBubbleRadius: 15,
    minBubbleRadius: 1,
    showLegend: true,
    useDefaultSort: false,
};

export const defaultBubbleProps = {
    legendPlacement: 'right',
    legendLabelOverflowMode: 'ellipsisMiddle',
    masterLegend: null,
    resultTruncationLimit: 50000,
    xAxisVisibility: 'hide',
    yAxisVisibility: 'hide',
    yAxisExtendsAxisRange: true,
    xAxisMajorLabelVisibility: 'auto',
    yAxisMajorLabelVisibility: 'auto',
    xAxisMajorTickSize: 6,
    yAxisMajorTickSize: 6,
    yAxisMinorTickSize: 6,
    xAxisMajorTickVisibility: 'auto',
    yAxisMajorTickVisibility: 'auto',
    yAxisMajorUnit: 'auto',
    yAxisMinorTickVisibility: 'auto',
    yAxisAbbreviation: 'none',
    yAxisIncludeZero: false,
    xAxisMax: 'auto',
    yAxisMax: 'auto',
    yAxisMin: 'auto',
    yAxisScale: 'linear',
    xAxisTitleVisibility: 'visible',
    yAxisTitleVisibility: 'visible',
    showMajorYGridLines: true,
    showMinorYGridLines: false,
    xAxisExtendsAxisRange: true,
    xAxisMajorLabelRotation: 0,
    xAxisMajorUnit: 'auto',
    xAxisAbbreviation: 'none',
    roundXAxisLabelsToInteger: false,
    xAxisMinorTickSize: 6,
    xAxisMinorTickVisibility: 'auto',
    xAxisIncludeZero: false,
    xAxisMin: 'auto',
    xAxisScale: 'linear',
    bubbleMaxSize: 50,
    bubbleMinSize: 10,
    bubbleSizeBy: 'area',
    showMinorXGridLines: false,
    xAxisMaxLabelParts: 3,
};

export const defaultScatterProps = {
    legendPlacement: 'right',
    legendLabelOverflowMode: 'ellipsisMiddle',
    masterLegend: null,
    resultTruncationLimit: 50000,
    xAxisVisibility: 'hide',
    yAxisVisibility: 'hide',
    yAxisExtendsAxisRange: true,
    xAxisMajorLabelVisibility: 'auto',
    yAxisMajorLabelVisibility: 'auto',
    xAxisMajorTickSize: 6,
    yAxisMajorTickSize: 6,
    yAxisMinorTickSize: 6,
    xAxisMajorTickVisibility: 'auto',
    yAxisMajorTickVisibility: 'auto',
    yAxisMajorUnit: 'auto',
    yAxisMinorTickVisibility: 'auto',
    yAxisAbbreviation: 'none',
    yAxisIncludeZero: false,
    xAxisMax: 'auto',
    yAxisMax: 'auto',
    yAxisMin: 'auto',
    yAxisScale: 'linear',
    xAxisTitleVisibility: 'visible',
    yAxisTitleVisibility: 'visible',
    showMajorYGridLines: true,
    showMinorYGridLines: false,
    xAxisExtendsAxisRange: true,
    xAxisMajorLabelRotation: 0,
    xAxisMajorUnit: 'auto',
    xAxisAbbreviation: 'none',
    roundXAxisLabelsToInteger: false,
    xAxisMinorTickSize: 6,
    xAxisMinorTickVisibility: 'auto',
    xAxisIncludeZero: false,
    xAxisMin: 'auto',
    xAxisScale: 'linear',
    showMinorXGridLines: false,
    markerSize: 4,
    xAxisMaxLabelParts: 3,
};
